export const defaultX = [20, 105]

export const outfield = ['lf', 'cf', 'rf']
export const infield = ['2b', '3b', 'ss']
export const positions = ['1b', ...infield, ...outfield]

export const positionMap = {
    3: '1b',
    4: '2b',
    5: '3b',
    6: 'ss',
    7: 'lf',
    8: 'cf',
    9: 'rf',
}
